module.exports = __webpack_public_path__ + "img/purple.3fb05035.svg";